import React from "react";

interface UserInitialsIconProps extends React.SVGProps<SVGSVGElement> {
  user: { name?: string } | null;
}

export const UserInitialsIcon: React.FC<UserInitialsIconProps> = (props) => {
  const fullName = props.user?.name ?? "none";
  const initials =
    fullName &&
    fullName
      .split("@")[0]
      .split(".")
      .map((word) => word[0])
      .join("")
      .toUpperCase();

  return (
    <span className="user-initials-icon">
      <svg viewBox="0 -20 50 50" width="50" height="50" {...props}>
        <circle cx="25" cy="5" r="15" stroke="white" strokeWidth="1" fill="none" />
        <text x="25" y="10" textAnchor="middle" fontSize="12" fill="white">
          {initials}
        </text>
      </svg>
    </span>
  );
};
